import { render, staticRenderFns } from "./VolunteerJobs.vue?vue&type=template&id=9108bd28&scoped=true&lang=pug&"
import script from "./VolunteerJobs.vue?vue&type=script&lang=js&"
export * from "./VolunteerJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9108bd28",
  null
  
)

export default component.exports